export default "__VITE_ASSET__kYv94spF__"